import { useMemo } from 'react';

type RetentionInfo = {
  value: number | undefined;
  unit: string | undefined;
};

export function useRetentionInfo(
  environment: string,
  environments: Record<string, unknown> | undefined
): RetentionInfo {
  return useMemo(() => {
    const env = environments?.[environment] as Record<string, any> | undefined;
    const retention = env?.retention?.type?.hot?.logs;

    return {
      value: retention?.value,
      unit: retention?.unit
    };
  }, [environment, environments]);
}
